export const menuNames = {
  MAIN: "Main",
  MENU: "Menu",
  REFERENCES: "References",
  LINKS: "Links",
};
